import { useRouter } from "next/router";
import React from "react";

import Checkbox from "@components/UI/Checkbox";
import FormattedMessage from "@components/UI/FormattedMessage";
import ReviewStars from "@components/UI/ReviewStars/ReviewStars";

import { ROUTES } from "@shared/constants";

import { getNewCheckboxFilterValue, parseStarsQueryParam } from "./helpers";

interface FilterBoxStarsProps {
  query: any;
  hotelStarCounts: Record<number, number>;
}

const FilterBoxStars: React.FC<FilterBoxStarsProps> = ({
  query,
  hotelStarCounts,
}) => {
  const router = useRouter();

  const changeCheckboxFilter = (key: string, code: string) => {
    router.push(
      {
        pathname: ROUTES.HOTELS,
        query: {
          ...getNewCheckboxFilterValue(query, key, code),
        },
      },
      undefined,
      { scroll: false }
    );
  };

  const stars = parseStarsQueryParam(query.stars);

  return (
    <div className="filters-box" id="filter-stars">
      <span className="filters-label">
        <FormattedMessage id="Hotels.filters.stars" />:
      </span>

      {[5, 4, 3, 2, 1].map((star, index) => (
        <div key={index} className="filter-stars-checkbox">
          <Checkbox
            key={star}
            customContainerClass="filter-airline-checkbox-container"
            customLabelClass="filter-airline-checkbox-label"
            id={`filter-stars-${star}`}
            label={<ReviewStars stars={star.toString()} />}
            onClick={() => {
              changeCheckboxFilter("stars", star.toString());
            }}
            checked={stars.includes(star.toString())}
          />
          <span>{hotelStarCounts[star] || 0}</span>
        </div>
      ))}
    </div>
  );
};

export default FilterBoxStars;
